import { Link } from 'found'
import { Helmet } from 'react-helmet'
import React, { Component } from 'react'
import { createFragmentContainer } from 'react-relay'
import graphql from 'babel-plugin-relay/macro' 

import SearchForm from '../category-page/search-form'
import NewsletterForm from '../../components/newletter-form'

// import imageMapHeader500w from "../../images/how-to-draw-world-map-for-kids-with-countries-within-drawing-at-drawings-of-the-1-p-500.png"
// import imageMapHeader800w from "../../images/how-to-draw-world-map-for-kids-with-countries-within-drawing-at-drawings-of-the-1-p-800.png"
// import imageMapHeader1024w from "../../images/how-to-draw-world-map-for-kids-with-countries-within-drawing-at-drawings-of-the-1.png"
import imagePlaceholder from "../../images/image-19-9-placeholder.svg"

class CityListPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            searchValue: ''
        }
    }

    handleSearch = (value) => {
        this.setState({
            searchValue: value.trim().toLowerCase()
        })
    }

    render() {
        console.log("CityList",this.props);
        let searchFilter = city => this.state.searchValue === '' || city.name.toLowerCase().includes(this.state.searchValue)
        let featured = this.props.cities.featured.filter(searchFilter)
        let cities = this.props.cities.cities.filter(searchFilter)
        let upcoming = this.props.cities.upcoming.filter(searchFilter)

        let featuredCities = featured.map(FeaturedCities)

        cities.sort((a,b) => {
            return (a.name > b.name ? 1 : -1)
        })

        upcoming.sort((a,b) => {
            return (a.name > b.name ? 1 : -1)
        })

        let allCities = []
        let nbPerRow = 4
        for (let i = 0; i < cities.length / nbPerRow; ++i) {
            let begin = i * nbPerRow
            let end = begin + nbPerRow
            let row = cities.slice(begin, end).map((city, index) =>
                <CityItem key={index} {...city}/>
            )
            allCities.push(<div className="row-19 w-row" key={'row' + i}>{row}</div>)
        }


        let upcomingCities = []
        for (let i = 0; i < upcoming.length / nbPerRow; ++i) {
            let begin = i * nbPerRow
            let end = begin + nbPerRow
            let row = upcoming.slice(begin, end).map((city, index) =>
                <CityItem key={index} {...city}/>
            )
            upcomingCities.push(<div className="row-19 w-row" key={i}>{row}</div>)
        }

        if (upcomingCities.length > 0)
            upcomingCities = (
                <div className="upcoming-cities-section">
                    <div className="upcoming">
                        <div className="text-block-40">Upcoming</div>
            {upcomingCities}
                    </div>
                </div>
            )
        else
            upcomingCities = ''

        if (upcomingCities.length === 0
            && allCities.length === 0
            && featuredCities.length === 0)
            allCities = 'No matching city'

        featuredCities = (
            <div className="all-cities-section">
                <div className="berlin-row-copy">
                    <div className="row-18 w-row">
                        {featuredCities}
                    </div>
                    {allCities}
                </div>
            </div>
        )

        const seo = this.props.seo;
        const generic = this.props.social.generic[0];
        const twitter = this.props.social.twitter[0];
        return (
            <div>
                <Helmet>
                    <title>Startup Guide - {seo.title?seo.title:'Cities'}</title>
                    <meta
                        content={seo.description ?seo.description: cities.reduce((a, b) => (a.length ? a + ', ' : '') + b.name, '')} 
                        name="description"
                    />

                    <meta content="website" property="og:type" />
                    <meta content={generic&&generic.title?generic.title:'Cities'} property="og:title" />
                    <meta content={generic&&generic.description?generic.description:'Cities'} property="og:description" />
                    <meta content={generic&&generic.image?generic.image:this.props.headerPicture} property="og:image" />
                    <meta property="og:url" content={"https://startupguide.com/cities/"}></meta>
                    <meta property="og:site_name" content="StartupGuide"></meta>

                    <meta name="twitter:card" content={twitter&&twitter.type.includes('Standard')?'summary':'summary_large_image'}></meta>
                    <meta name="twitter:site" content="@StartupGuideHQ"></meta>
                    <meta name="twitter:creator" content={twitter&&twitter.handle?twitter.handle:'@StartupGuideHQ'}></meta>
                    <meta name="twitter:title" content={twitter&&twitter.title?twitter.title:'Cities'}></meta>
                    <meta name="twitter:description" content={twitter&&twitter.description?twitter.description:'Cities'}></meta>
                    <meta name="twitter:image" content={twitter&&twitter.image?twitter.image:this.props.headerPicture}></meta>

                </Helmet>
                <div className="map-header">
                    <img alt="" src={this.props.headerPicture} width="1007" className="image-55" />
                </div>
                <div className="trending-cities-section">
                    <div className="all-cities-header">
                        <div className="text-block-28">All Locations</div>
                        <div className="div-block-39">
                            <SearchForm
                                className="div-block-40"
                                placeholder="Search city"
                                onChange={this.handleSearch}
                            />
                        </div>
                    </div>
                </div>
                {featuredCities}
                {upcomingCities}
                <NewsletterForm />
            </div>
        )
    }
}

const FeaturedCities = city => (
    <div key={city.slug} className="column-40 w-col w-col-4 w-col-stack">
        <div className="div-block-41 berlin-color" style={{borderColor: city.color}}>
            <img alt="" src={imagePlaceholder} className="city-icons" />
            <h3 className="heading-11 berlin" style={{color: city.color}}>{city.name}</h3>
            <div className="text-block-29">{city.description}</div>
        </div>
    </div>
)

const CityItem = city => (
    <Link key={city.slug} to={city.link}>
        <div className="row-cities-2 w-col w-col-3 w-col-medium-6">
            <div className="div-block-42 aarhus" style={{borderColor: city.color}}>
                <img alt="" src={city.picture} className="city-icons" />
                <h3 className="heading-11 aarhus" style={{color: city.color}}>{city.name}</h3>
                <div className="text-block-29">{city.description}</div>
            </div>
        </div>
    </Link>
)

const connectRelay = CityListPage => class extends Component {
    render() {
        const { routeResolver } = this.props.context
        let all = this.props.query.cities.map(c => ({ ...c, link: routeResolver.location.get(c.slug) }))
        let available = []
        let featured = []
        let upcoming = []
        all && all.forEach((city) => {
            if (city.availability === 'Available')
                available.push(city)
            else
                upcoming.push(city)
            if (city.featured)
                featured.push(city)
        })
        let cities = {
            cities: available,
            featured: featured,
            upcoming: upcoming,
        }
        let overview = this.props.query.citiesOverview;
        return <CityListPage headerPicture={overview.cover} seo={overview.seo} social={overview.social} cities={cities} />
    }
}

const CityListFragment = createFragmentContainer(
    connectRelay(CityListPage),
    graphql`
        fragment cityListPage_query on Query {
            citiesOverview {
                cover
                seo {
                    title
                    description
                }
                social {
                    twitter {
                        type
                        title
                        image
                        handle
                        description
                    }
                    generic {
                        title
                        image
                        description
                    }
                }
            }
            cities {
                slug
                name
                caption
                picture
                color
                featured
                availability
            }
        }
    `
)

export default (props) => <CityListFragment query={props} {...props} />
